<template>
  <div>
    <admin-wrapper
      title-translation-path="admin.DB2GIS"
      :module-enabler="moduleEnabler"
      :inputs="inputs"
      :has-buttons="false"
      :is-form-fetched="isFormFetched"
    >
      <template #table.input>
        <external-systems-table
          attribute-id-name="datasource_field"
          :inputs="dbGisInputs"
          :external-systems="externalSystems"
          :available-systems="availableSystems"
          :init-gets="initGets"
          :delete-connection="deleteConnection"
          :edit-connection="editConnection"
          :add-connection="addConnection"
          :refresh-view="refreshView"
        />
      </template>
    </admin-wrapper>
  </div>
</template>

<script>
import AdminWrapper from '@/components/AdminWrapper';
import ExternalSystemsTable from '@/components/ExternalSystemsTable';
import { call, get } from 'vuex-pathify';
export default {
  name: 'DbGisSettings',
  components: { ExternalSystemsTable, AdminWrapper },
  data: () => ({
    isFormFetched: false,
  }),
  computed: {
    externalSystems: get('externalSystems/dbGisSystems'),
    availableSystems: get('externalSystems/availableDbGisSystems'),
    isModuleEnabled: get('admin/settingsValues@db2gis_module_enabled'),
    dbGisInputs() {
      return [
        'name',
        'system',
        'host',
        'port',
        'username',
        'password',
        'dbname',
        'schema_name',
        'table_name',
        'source_field',
        'datasource',
        'datasource_field',
      ];
    },
    inputs() {
      return [
        {
          name: 'table',
          hasSuffix: false,
          isCustom: true,
          isNamedSlot: false,
        },
      ];
    },
    moduleEnabler() {
      return {
        name: 'db2gis_module_enabled',
        translationPath: 'admin.DB2GIS',
        subtitle: this.$i18n.t('admin.moduleEnablerSubtitle', { suffix: this.$i18n.t('admin.DB2GIS') }),
      };
    },
  },
  methods: {
    getExternalSystems: call('externalSystems/getDbGisSystems'),
    getAvailableSystems: call('externalSystems/getAvailableDbGisSystems'),
    deleteConnection: call('externalSystems/deleteDbGisConnection'),
    addConnection: call('externalSystems/addDbGisConnection'),
    editConnection: call('externalSystems/editDbGisConnection'),
    refreshView: call('externalSystems/refreshDbGisView'),
    getDataSources: call('layers/getLayersMetadata'),
    async init() {
      await Promise.all([this.getDataSources({ with_attributes_schema: true })]);
      this.isFormFetched = true;
    },
    async initGets() {
      await this.getExternalSystems();
      await this.getAvailableSystems();
    },
  },
  watch: {
    isModuleEnabled(nV) {
      if (nV) {
        this.isFormFetched = false;
        this.init();
      }
    },
  },
  created() {
    if (this.isModuleEnabled) {
      this.init();
    } else {
      this.isFormFetched = true;
    }
  },
};
</script>

<style scoped></style>
